import SearchFields from "../SearchFields";

const ApplicationSearch = () => (
  <main className="main">
    <SearchFields placeholder="Enter Application ID" entity="applications" />
  </main>
);

export default ApplicationSearch;
